import { ButtonComponent } from './button.component';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgClass } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'button[mweButton]',
  templateUrl: './button-attr.component.html',
  host: {
    '(click)': 'onClick($event)',
    '[attr.data-test]': 'buttonId()',
    '[attr.title]': '(title()) || null',
    '[attr.aria-label]': '(title()) || null',
    '[attr.aria-expanded]': 'ariaExpanded()',
    '[attr.aria-pressed]': 'active() || null',
    '[attr.type]': 'buttonType()',
    '[disabled]': 'disabled()',
    '[attr.id]': 'buttonId() || null',
    '[class]': 'btnCssClasses()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, TranslatePipe],
})
export class ButtonAttrComponent extends ButtonComponent {}
